import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

export type AppTheme = 'light' | 'dark';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly storageKey = 'advcare-theme';
  private readonly document = inject(DOCUMENT);
  private currentTheme: AppTheme = 'light';

  constructor() {
    this.currentTheme = this.readStoredTheme();
    this.applyTheme(this.currentTheme);
  }

  getTheme(): AppTheme {
    return this.currentTheme;
  }

  isDark(): boolean {
    return this.currentTheme === 'dark';
  }

  toggleTheme(): AppTheme {
    const nextTheme: AppTheme = this.currentTheme === 'dark' ? 'light' : 'dark';
    this.setTheme(nextTheme);
    return nextTheme;
  }

  setTheme(theme: AppTheme): void {
    this.currentTheme = theme;
    localStorage.setItem(this.storageKey, theme);
    this.applyTheme(theme);
  }

  private readStoredTheme(): AppTheme {
    const stored = localStorage.getItem(this.storageKey);
    return stored === 'dark' ? 'dark' : 'light';
  }

  private applyTheme(theme: AppTheme): void {
    const body = this.document.body;
    body.classList.remove('theme-light', 'theme-dark');
    body.classList.add(theme === 'dark' ? 'theme-dark' : 'theme-light');
    body.style.colorScheme = theme;
  }
}
